import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerModalBaseComponent } from '../shared/customer-modal-base.component';

export class HistoricalCharacteristicContext {
    constructor(public identificationId: number, public customerNumberId: number) {}
}

@Component({
    templateUrl: './historical-customer-characteristic-modal.html'
})
export class HistoricalCustomerCharacteristicModalComponent extends CustomerModalBaseComponent {
    customerNumberId: number;

    constructor(public location: PlatformLocation,
        public dialogRef: MatDialogRef<HistoricalCustomerCharacteristicModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: HistoricalCharacteristicContext,
        public modalService: MvdModalService) {
        super(modalService);

        this.customerNumberId = this.data.customerNumberId;
    }

    ngOnInit() { }

    public cancel() {
        this.dialogRef.close();
    }
}
